import axios from "axios";
import type { AxiosResponse } from "axios";

export function createSubscription(
  customer_id: string,
  email: string,
  price_id: string,
  paymentMethodId: string
): Promise<AxiosResponse> {
  return axios.post("/.netlify/functions/stripe-create-subscription", {
    customer_id,
    email,
    price_id,
    paymentMethodId
  });
}
